import axios from "axios";
import { authRedirectGate } from "../utils/authRedirectGate";

// CONSTANT BASEURL FRONTEND API
// export const baseURL =
//   "https://logical-dividend-aberdeen-cardiac.trycloudflare.com";
// export const baseURL = "http://localhost:8000";
export const baseURL = "https://stg.xenorize.com";
// export const baseURL = "http://192.168.0.107:8000";
// export const baseURL = "https://xenorize.com";

export const baseAxios = axios.create({
  baseURL,
  withCredentials: true,
});

export const defaultAxios = axios.create({
  baseURL,
});

// This interceptor function will run for every response that comes back from the API
baseAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    //  if suppressed, never hard redirect
    if (authRedirectGate.suppress401Redirect) {
      return Promise.reject(error);
    }
    // Check if we have a response and the status is 401
    if (error.response && error.response.status === 401) {
      // V-- The New Condition --V
      // Only redirect if the failed request was NOT for '/api/user-detail'
      if (error.config.url !== "/api/user-detail") {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      }
    }

    // Always reject the promise so the original .catch() can handle it
    return Promise.reject(error);
  }
);
